import { render, staticRenderFns } from "./NewAccountSummary.vue?vue&type=template&id=374b959e&scoped=true&"
import script from "./NewAccountSummary.vue?vue&type=script&lang=js&"
export * from "./NewAccountSummary.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountSummary.vue?vue&type=style&index=0&id=374b959e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b959e",
  null
  
)

export default component.exports